import { useAdminUsuarios } from "../../../Hooks/Admin";

export const tabList = (setKey, activeTabKey) => {
  const tabs = useAdminUsuarios({ setKey, activeTabKey });

  return [
    {
      key: "lista",
      label: "Lista de usuarios",
      children: tabs["lista"]()
    },
    {
      key: "data",
      label: "Data del usuario",
      children: tabs["data"]()
    },
    {
      key: "logros",
      label: "Logros",
      children: tabs["logros"]()
    },
    {
      key: "pokemones",
      label: "Pokemones del usuario",
      children: tabs["pokemones"]()
    },
    {
      key: "objetos",
      label: "Objetos del usuario",
      children: tabs["objetos"]()
    },
    {
      key: "pokedex",
      label: "Pokedex",
      children: tabs["pokedex"]()
    }
  ];
}
